import { useReduxState } from 'hooks';
import { DropdownSelectable } from 'components/common/dropdown';

import type { Chapter } from 'shared-types';

interface Props {
  chapters: (Pick<Chapter, 'id' | 'title'> & { number: number })[];
  onChange?: (id: number) => void;
}

const ChaptersDropdownFilter = ({ chapters, onChange }: Props) => {
  const { messages } = useReduxState();

  const handleChange = async (chapterId: number) => {
    if (onChange) onChange(chapterId);
  };

  return !chapters ? null : (
    <DropdownSelectable
      category="lighter"
      defaultValue={null}
      defaultText={messages.commonAllChapters}
      dropdownTextMinWidth="150px"
      onChange={handleChange}
      options={[
        {
          text: messages.commonAllChapters,
          value: null
        },
        ...chapters.map((chapter) => ({
          text: `${chapter.number}. ${chapter.title}`,
          value: chapter.id
        }))
      ]}
      showArrow={true}
      showSelectedText={true}
    />
  );
};

export default ChaptersDropdownFilter;
